/*@flow*/
import type { Node } from 'react'; /** @jsx jsx */
import { jsx } from '@emotion/core';
import Joyride from 'react-joyride';

export default function TutorialPanel({
  onReset,
}: {
  onReset?: Function,
}): Node {
  const steps = [
    {
      target: '#LOCATION_DETAILS',
      content:
        'Interact with the map records. View as a list, search, filter and analyze the data displayed on this map.',
      disableBeacon: true,
      disableOverlayClose: true,
      hideCloseButton: true,
      hideFooter: false,
      placement: 'bottom',
      spotlightClicks: true,
      styles: {
        options: {
          zIndex: 10000,
        },
      },
    },
    {
      target: '.project-dot',
      content:
        "Click on dots to open a popup. For more information, click the name in the popup to open the location's details in the sidebar.",
    },
    {
      target: '.draw-btn',
      content:
        'Define a custom area. Analyze and download data for custom areas.',
    },
  ];

  return (
    <Joyride
      steps={steps}
      continuous
      showProgress
      callback={(data) => {
        if (data.action === 'reset') {
          onReset && onReset();
        }
      }}
    />
  );
}
